module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/1/5-55481a1d88758056c41e36dffae692d6.jpg";